import React from 'react';
import { IActivityLogTab } from './interfaces';
import { Tab } from '../../Tab';
import { useTranslation } from 'react-i18next';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

export const ActivityLogTab: React.FC<IActivityLogTab> = ({
  label,
  ...other
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tab
      label={label || t('tabs.activityLog')}
      icon={<QuestionAnswerIcon />}
      {...other}
    />
  );
};
